<template>
  <div class="d-flex align-center ga-2">
    <v-tooltip :text="$t('aiAssistant.feedback.goodResponse')" open-delay="300" location="top">
      <template v-slot:activator="{ props }">
        <v-btn
          v-bind="props"
          icon
          variant="text"
          size="small"
          color="default"
          @click="handleFeedback(FeedbackRating.HELPFUL)"
          :class="[
            'ai-feedback-btn',
            { 'ai-feedback-btn--active': feedbackRating === FeedbackRating.HELPFUL },
          ]"
        >
          <v-icon size="16" icon="$like" />
        </v-btn>
      </template>
    </v-tooltip>
    <v-tooltip :text="$t('aiAssistant.feedback.badResponse')" open-delay="300" location="top">
      <template v-slot:activator="{ props }">
        <v-btn
          v-bind="props"
          icon
          variant="text"
          size="small"
          color="default"
          @click="handleFeedback(FeedbackRating.UNHELPFUL)"
          :class="[
            'ai-feedback-btn',
            { 'ai-feedback-btn--active': feedbackRating === FeedbackRating.UNHELPFUL },
          ]"
        >
          <v-icon size="16" icon="$dislike" />
        </v-btn>
      </template>
    </v-tooltip>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
import { FeedbackRating } from "@/constants/ai-assistant.ts";

export default defineComponent({
  props: {
    feedbackRating: {
      type: String as PropType<FeedbackRating | null>,
      default: null,
    },
  },
  emits: ["feedback-submitted"],
  setup(_, { emit }) {
    const handleFeedback = (rating: FeedbackRating) => {
      emit("feedback-submitted", rating);
    };

    return {
      handleFeedback,
      FeedbackRating,
    };
  },
});
</script>

<style lang="scss" scoped>
.ai-feedback-btn {
  height: 24px !important;
  width: 24px !important;
  opacity: 0.7;

  &:hover {
    opacity: 1;
    background-color: rgba(0, 0, 0, 0.04);
  }

  &--active {
    opacity: 1 !important;
    border-radius: 50% !important;
    background-color: rgb(var(--v-theme-primary)) !important;

    .v-icon:before {
      color: rgb(var(--v-theme-white)) !important;
    }

    &:hover {
      background-color: rgb(var(--v-theme-primary)) !important;
    }
  }
}
</style>
